<template>
  <div class="number">
    <CountDownCircle ref="circle" class="circle" />
    <div class="num" v-if="counts[0]">{{counts[0]}}</div>
    <span class="after-seconds">秒後に開始</span>
  </div>
</template>

<script>
export default {
  name: "CountDown",
  components: {
    CountDownCircle: require("./CountDownCircle").default
  },
  data() {
    return {
      counts: [],
      current: 5,
      timer: null,
      showNumber: false
    };
  },
  methods: {},
  mounted() {
    let self = this;
    this.counts.push(this.current);
    this.timer = setInterval(() => {
      if (this.counts.length > 0) {
        this.counts.shift();
      }
      this.showNumber = true;
      this.current--;
      if (this.current > 0) {
        this.$refs.circle.updateProgress(25);
      }
      this.counts.push(this.current);
      if (this.current < 2) {
        self.showContdownWindow = false;
        clearInterval(self.timer);
        setTimeout(() => {
          self.$emit("finished-count-down");
        }, 1200);
      }
    }, 1200);
  }
};
</script>

<style scoped>
.number {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  margin: auto;
  height: 100%;
  width: 100%;
}
.num {
  display: inline-block;
  font-size: 100px;
  line-height: 100px;
  font-weight: 900;
  z-index: 300;
}

.after-seconds {
  display: inline-block;
  z-index: 300;
  font-size: 1.2rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
